import { AxiosResponse } from 'axios';
import api from './Api'


export const requestSmsAuthSend = (countryCode: string, mobile: string): Promise<AxiosResponse<void, any>> => {
        return api.get(`/naver-cloud/${countryCode}/${mobile}`);
}